module.exports = __webpack_public_path__ + "static/media/syncWhatsapp_step1_hk.93c0a153.jpg";